import { Modal, notification } from 'antd'
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import axiosInstance from '../../../../../Services/axiosCommon';
import { NuInput, NuSelect } from '../../../../../Components/Utils/Input';
import { CancelButton, SubmitButton } from '../../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../../Components/Utils/Select';
import useFetchMataData from '../../../../../Components/Hooks/useFetchMataData';
import UseDropDown from '../../../../../Components/Hooks/useDropDown';
import { useParams } from 'react-router-dom';
import UseDropDownPro from '../../../../../Components/Hooks/useProDD';


function CreateSubItemsBOQ({open,onCancel,getData,estiId,itId,refMaterialProgressUnit=()=>{},Activity,Unit}) {
  // console.log("finding",estiId);
  // const { value: Unit } = useFetchMataData(
  //   `/dropdown/dropdown-details/`,
  //   "Unit_item"
  // );
  // const {value:Unit ,getData:refMaterialUnit} = useFetchMataData(`/dropdown/dropdown-details/`,'Unit_item')

const {officeId}=useParams();

  const [api, contextHolder] = notification.useNotification();
  const [isLoading,setIsLoading] = useState(false);
  const [createNew, setCreateNew] = useState({
    item: "",
    unit: "",
    quantity: "",
    unitPrice: "",
    totalPrice: "",
    estimationId: "",
    IT_Id: ""
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema:yup.object({
      item:yup.string().required("Item Name is Requried")
    }),
    onSubmit: (value,{resetForm}) => {    
      setIsLoading(true);
      const values = {
        ...value,
        estimationId: Number(estiId),
        IT_Id: itId,
      }
      axiosInstance
      .post(`/BOQ/single-BOQ`, values)
        .then((res) => {
          console.log(res);
          if (res.status === 201 || res.data.status == true) {
            setIsLoading(false);
            getData();
            resetForm();
            api.success({
              message: `BOQ Item Creation successfully`,
              description: res?.data?.msg || "Added In Tittle",
              placement: "bottomRight",
            });
            onCancel();
          } else {
            api.error({
              message: `BOQ Item  Creation failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
            setIsLoading(false);
          }
        })
        .catch((err) => {
          api.error({
            message: `BOQ Item Creation failed`,
            description: err?.data?.msg || "Sever error (or) Network error",
            placement: "bottomRight",
          });
          setIsLoading(false);
        });
    },
  });

  useEffect(() => {
    const totalPrice = formik?.values?.quantity * formik?.values?.unitPrice
    formik.setFieldValue("totalPrice", totalPrice);
  }, [formik?.values?.quantity,formik?.values?.unitPrice]);

  return (
    <>
    {contextHolder}
    <Modal
      open={open}
      title={"Create Task"}
      width={"50%"}
      className="my-modal"
      centered
      footer={[]}
      onCancel={onCancel}
    >
    <form onSubmit={formik.handleSubmit} >
      <div className=" w-full flex flex-wrap">
         {/* <NuInput
          type="text"
              label="Item Name"
              placeholder="Item Name"
              formik={formik}
              name="item"
              width="w-full"
              isRequired={true}
          /> */}
           <FormikSelectTwo
              type="text"
              label="Item "
              placeholder="Choose"
              Options={Activity}
              formik={formik}
              name="item"
              isRequired={true}

              width="w-full "
                     />
            <FormikSelectTwo
            label="Unit"
            Options={Unit}
            formik={formik}
            placeholder="Choose"
            name="unit"
            width="w-full md:w-1/2"
          
            />
           <NuInput
            type="number"
              label="Quantity"
              placeholder="Quantity"
              formik={formik}
              name="quantity"
              width="w-full md:w-1/2"
            />
            <NuInput
             type="number"
              label="Unit Price"
              placeholder="Unit Price"
              formik={formik}
              name="unitPrice"
              width="w-full md:w-1/2"
            />
            <NuInput
             type="number"
              label="Total Price"
              placeholder="Total Price"
              formik={formik}
              name="totalPrice"
              width="w-full md:w-1/2"
              disabled={true}

            />
            <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
              <CancelButton handleClick={onCancel} />
              <SubmitButton isLoading={isLoading} />
            </div>
      </div>
      </form>
    </Modal>
    </>
  )
}

export default CreateSubItemsBOQ